import React, { MouseEventHandler } from 'react';
import Separator from '@westwing/ui-kit/Separator';
import EmailIcon from '@westwing/ui-kit/Icons/EmailIcon';
import {
    StyledHeader,
    StyledModalTitle,
    StyledModalContent,
    StyledListItem,
    StyledModalParagraph,
    StyledLink,
    StyledLinkButton,
    StyledHeaderIcon,
} from '../loginAndRegistration.style';
import useTranslate from 'Hooks/useTranslate';

type ResetPasswordConfirmationProps = {
    email: string;
    editEmailUrl: string;
    onResend: MouseEventHandler<HTMLButtonElement>;
};

const ResetPassword = ({ email, editEmailUrl, onResend }: ResetPasswordConfirmationProps): JSX.Element => {
    const { tPlain: t } = useTranslate();

    const title = t('Please check your inbox');
    const description = t('Password confirm info_bella', [email]);
    const linkDescription = t('Click on link');
    const editEmailLabel = t('Oops! I have entered a wrong email address.');
    const resendLabel = t('Send e-mail again');

    return (
        <div>
            <StyledHeader>
                <StyledHeaderIcon>
                    <EmailIcon />
                </StyledHeaderIcon>
                <StyledModalTitle>{title}</StyledModalTitle>
            </StyledHeader>
            <StyledModalContent>
                <StyledModalParagraph>{description}</StyledModalParagraph>
                <StyledModalParagraph>{linkDescription}</StyledModalParagraph>

                <Separator />
                <ul>
                    <StyledListItem>
                        <StyledLink to={editEmailUrl}>{editEmailLabel}</StyledLink>
                    </StyledListItem>
                    <StyledListItem>
                        <StyledLinkButton onClick={onResend}>{resendLabel}</StyledLinkButton>
                    </StyledListItem>
                </ul>
            </StyledModalContent>
        </div>
    );
};
export default ResetPassword;
